import { Injectable } from '@angular/core';

import { ScheduledActivity } from '../../../shared/interfaces';
import { SignageConfigurationModel } from '../../config/models';
import { RuntimeSlideModel } from '../../slides/models';
import { BuildContextModel, FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind, SlideLayout, SlideTimingKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class ScheduledVideoContentProvider implements ContentProvider<ScheduledActivity> {
  public readonly kind = ContentKind.ScheduledVideo;
  public readonly tier = RefreshTier.Main;
  public readonly order = 70;
  public readonly presentation = PresentationSlot.Interrupt;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public fetch(context: FetchContextModel): Promise<ScheduledActivity[]> {
    return context.source.loadScheduledVideos(context.config.channel, context.signal);
  }

  public toSlides(items: ScheduledActivity[], context: BuildContextModel): RuntimeSlideModel[] {
    return items.filter(item => !!item.youTubeId && Number.isFinite(Date.parse(item.startTime))
      && Date.parse(item.endTime) > Math.max(context.clock.now().toEpochMilli(), Date.parse(item.startTime))).map(item => ({
      id: `scheduled-video:${item.youTubeId}:${item.startTime}`, kind: this.kind, layout: SlideLayout.Video,
      content: { id: 0, providerChannelIds: item.providerChannelIds || [], title: item.title, videoId: item.youTubeId },
      duration: { kind: SlideTimingKind.Media, expectedMilliseconds: Date.parse(item.endTime) - Date.parse(item.startTime) },
      meta: { sourceId: 0, startsAt: Date.parse(item.startTime), expiresAt: Date.parse(item.endTime) }
    }));
  }
}
